<template>
  <div class="item b-img">
    <div class="title">앱을 통한 <b>간편한 신청</b></div>
    <div class="content">
      개설 이후 클릭 한번으로 간편한 신청!<br />
      서류 접수도 온라인으로!
    </div>
    <div class="content2">
      <div class="item-detail">
        <img src="@/assets/images/fundanow-style-main/SectionReason/item2.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Two',
}
</script>

<style lang="scss" scoped>
* {
  font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
}
.item {
  font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
  background-color: white;
  width: 280px;
  height: 340px;
  border-radius: 6px;
  box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
  padding-top: 23px;
  background-image: url('../../../../assets/images/fundanow-style-main/SectionReason/bg2.svg');
  overflow: hidden;

  .title {
    font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
    font-weight: 500;
    font-size: 20px;
    line-height: 1.35;
    letter-spacing: -0.63px;
    text-align: center;
    color: #333333;
    b {
      font-weight: 800;
      color: #333333;
    }
  }

  .content {
    font-weight: 500;
    font-size: 15px;
    line-height: 1.4;
    letter-spacing: -0.47px;
    text-align: center;
    color: #727d8c;
    margin-top: 9px;
  }

  .content2 {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    margin-top: 42px;
    align-items: center;
    justify-content: center;
  }

  .app {
    width: 100%;
    left: 0px;
    bottom: 0px;
  }
}
</style>
